/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminConnectToTeamsRequest
 */
export interface AdminConnectToTeamsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminConnectToTeamsRequest
     */
    userId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminConnectToTeamsRequest
     */
    teamIds?: Array<string> | null;
}

export function AdminConnectToTeamsRequestFromJSON(json: any): AdminConnectToTeamsRequest {
    return AdminConnectToTeamsRequestFromJSONTyped(json, false);
}

export function AdminConnectToTeamsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminConnectToTeamsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'teamIds': !exists(json, 'teamIds') ? undefined : json['teamIds'],
    };
}

export function AdminConnectToTeamsRequestToJSON(value?: AdminConnectToTeamsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'teamIds': value.teamIds,
    };
}


